import { render, staticRenderFns } from "./SqlViewer.vue?vue&type=template&id=4822e3dc"
import script from "./SqlViewer.vue?vue&type=script&lang=js"
export * from "./SqlViewer.vue?vue&type=script&lang=js"
import style0 from "./SqlViewer.vue?vue&type=style&index=0&id=4822e3dc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports